import React from "react";

export const Developers = React.lazy(() => import("./Developers"))
export const About = React.lazy(() => import("./About"))
export const Home = React.lazy(() => import("./Home"))
export const Projects = React.lazy(() => import("./Projects"))
export const Team = React.lazy(() => import("./Team"))
export const Testimonial = React.lazy(() => import("./Testimonials"))
export const ImageGallery = React.lazy(() => import("./Imagegallery"))